__webpack_require__.p = "https://boredui.cdn.orders.vpsvc.com/";